import { TYPES } from '@Types';
import { inject, injectable } from 'inversify';
import { ApiClient, annoncement } from '@Api';
import { RequestAction, RequestFailure } from '@Repository/RequestAction';
import { RequestAnnoncementSuccess } from './response';
import { Locale } from '@Repository/locale';
import { AnnoncementMapper } from '@Mapper/user/AnnoncementMapper';
import { Nullable, Annoncement } from '@Models';
import { CACHE_NAME } from '@Worker/CacheManager';

@injectable()
export class AnnoncementRepository {
  @inject(TYPES.Locale) private _locale!: Locale;
  @inject(TYPES.Api.ApiClient) private _apiClient!: ApiClient;
  @inject(TYPES.Mapper.AnnoncementMapper)
  private _annoncementMapper!: AnnoncementMapper;

  public async getLast(): Promise<RequestAction> {
    try {
      const dto = await this._apiClient.user.getLastAnnoncement({
        locale: this._locale.getlocale(),
      });
      this.setCachedEntity(dto);
      return new RequestAnnoncementSuccess({
        payload: this._annoncementMapper.map(dto),
      });
    } catch (error: any) {
      console.log('error', error);
      return new RequestFailure({ error: error });
    }
  }

  public async getCached(): Promise<Nullable<Annoncement>> {
    try {
      const cache = await caches.open(CACHE_NAME);
      const response = await cache.match(`/user/annoncement`);
      if (!response) return await null;

      const json: annoncement = JSON.parse(await response.text());
      if (!json) return null;

      return this._annoncementMapper.map(json);
    } catch (err) {
      console.log('error-load-cache', err);
    }
    return null;
  }

  protected async setCachedEntity(data: annoncement): Promise<void> {
    try {
      const cache = await caches.open(CACHE_NAME);
      await cache.put(`/user/annoncement`, new Response(JSON.stringify(data)));
    } catch (err) {
      console.log('error-save-cached-entity', err);
    }
  }

  public async isHidden(annoncementId: number): Promise<boolean> {
    try {
      const cache = await caches.open(CACHE_NAME);
      const response = await cache.match(
        `/user/annoncement/${annoncementId}/hidden`,
      );

      return response != undefined;
    } catch (err) {
      console.log('error-load-cache', err);
    }
    return false;
  }

  public async hidde(annoncementId: number): Promise<void> {
    try {
      const cache = await caches.open(CACHE_NAME);
      await cache.put(
        `/user/annoncement/${annoncementId}/hidden`,
        new Response(JSON.stringify(true)),
      );
    } catch (err) {
      console.log('error-save-cached-entity-hidden', err);
    }
  }
}
